import { siteInfo } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-fire-line text-white text-sm"></i>
              </span>
              <span className="text-lg font-heading font-bold text-white">
                {siteInfo.name}
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              全网最全黑料吃瓜合集平台。每日更新50+条爆料内容，覆盖娱乐、网红、电竞、直播等多个领域，为860万+吃瓜群众提供一站式的吃瓜体验。理性吃瓜，快乐无限。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速导航</h4>
            <div className="space-y-2.5">
              <a href="#hero" onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }} className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors">首页</a>
              <a href="#cards" onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }} className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors">热门爆料</a>
              <a href="#ranking" onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }} className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors">吃瓜排行榜</a>
              <a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors">专题合集</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">热门话题</h4>
            <div className="flex flex-wrap gap-2">
              <span className="px-3 py-1 text-xs bg-white/10 text-foreground-200 rounded-full whitespace-nowrap">明星八卦</span>
              <span className="px-3 py-1 text-xs bg-white/10 text-foreground-200 rounded-full whitespace-nowrap">网红翻车</span>
              <span className="px-3 py-1 text-xs bg-white/10 text-foreground-200 rounded-full whitespace-nowrap">电竞内幕</span>
              <span className="px-3 py-1 text-xs bg-white/10 text-foreground-200 rounded-full whitespace-nowrap">直播圈</span>
              <span className="px-3 py-1 text-xs bg-white/10 text-foreground-200 rounded-full whitespace-nowrap">商圈风云</span>
              <span className="px-3 py-1 text-xs bg-white/10 text-foreground-200 rounded-full whitespace-nowrap">社会热点</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-400">
              诚邀各类内容平台、媒体机构成为合作伙伴，详情请通过投稿渠道联系。
            </p>
            <div className="mt-4">
              <h4 className="text-sm font-semibold text-white mb-3">联系我们</h4>
              <div className="space-y-2">
                <div className="flex items-center gap-2 text-sm text-foreground-300">
                  <i className="ri-mail-line text-foreground-400"></i>
                  <span>tougao@heimrds.com</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-300">
                  <i className="ri-wechat-line text-foreground-400"></i>
                  <span>heimrds666</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-white/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; 2023-2026 {siteInfo.name}. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer">用户协议</span>
              <span className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer">隐私政策</span>
              <span className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer">免责声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}